import 'client-only';

import { useEffect } from 'react';

import { type Brand } from '@/consts/brands';
import { type AnalyticsPatientResource } from '@/types/metrics/analyticsPatient';

declare global {
  interface Window {
    CUROLOGY_ENV?: {
      APP_BRAND?: string;
    };
    duet?: {
      setMetadata: (metadata: {
        email?: string;
        name?: string;
        path?: string;
      }) => void;
      setUserId: (userId: string) => void;
      updateStyle: (style: { [key: string]: string | number }) => void;
    };
  }
}

const decagonIframeLoaded = (
  brand: string | null | undefined,
  callback: () => void,
) => {
  setTimeout(() => {
    if (typeof document !== 'undefined') {
      if (brand) {
        const decagonIframe = document.querySelector(
          `[src="https://decagon.ai/demo/${brand}"]`,
        );

        if (decagonIframe) {
          decagonIframe.addEventListener('load', callback);
        } else {
          decagonIframeLoaded(brand, callback);
        }
      } else {
        decagonIframeLoaded(brand, callback);
      }
    }
  }, 50);
};

export const useDecagonChatBot = (
  brand?: Brand,
  patient?: AnalyticsPatientResource,
) => {
  const brandName = brand ?? window?.CUROLOGY_ENV?.APP_BRAND ?? patient?.brand;

  useEffect(() => {
    // We only want this to run once.
    if (document.getElementById('decagon-script') || !brandName) {
      return;
    }

    const script = document.createElement('script');
    script.setAttribute('id', 'decagon-script');
    script.src = `https://decagon.ai/loaders/${brandName}.js`;
    script.async = true;

    document.body.appendChild(script);
  }, [brandName, patient]);

  decagonIframeLoaded(brandName, () => {
    window.duet?.setMetadata({
      email: patient?.email,
      name: patient?.fullName,
      path: window.location.pathname,
    });

    if (patient) {
      window.duet?.setUserId(String(patient.id));
    }

    window.duet?.updateStyle({
      zIndex: 999994, // Allow modals to be above the chatbot. Otherwise, scrolling breaks in iOS.
    });
  });
};
